const forgottenPassword = {
  forgotPassword: 'Passwort vergessen',
  enterEmail: 'Geben Sie hier Ihre E-Mail Adresse ein, mit der Sie registriert sind. Wenn dazu ein Konto besteht, schicken wir Ihnen einen Link zum Ändern des Passwortes zu.',
  successAlert: 'Vielen Dank! Wir haben eine E-Mail an Ihr Postfach gesendet. Diese enthält einen Link, den Sie anklicken müssen, um Ihr Passwort zurückzusetzen.',
  pleaseNote: 'Bitte beachten:',
  everyTwoHours: 'Sie können lediglich einmal innerhalb von 2 Stunden ein neues Passwort anfordern.',
  checkSpam: 'Wenn Sie keine E-Mail erhalten haben, sehen Sie bitte in Ihrem Spam-Ordner nach.',
  errorAlert: 'Zu viele Anforderungen zum Zurücksetzen des Passworts. Sie können alle 2 Stunden ein neues Passwort anfordern. Bitte versuchen Sie es später noch einmal.',
  email: 'E-Mail-Adresse',
  resetPassword: 'Passwort zurücksetzen',
  enterNewPassword: 'Geben Sie hier Ihr neues Passwort ein. Wir fragen nach diesem Passwort, wenn Sie sich erneut anmelden.',
  newPassword: 'Neues Passwort',
  repeatPassword: 'Neues Passwort bestätigen',
  back: 'Zurück',
  changePassword: 'Passwort ändern',
  characterValidations: 'Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben und 1 Zahl enthalten',
  notice: 'Hinweis:',
  passwordHintText: 'Das Passwort muss mindestens 8 Zeichen lang sein und 1 Großbuchstaben, 1 Kleinbuchstaben, 1 Zahl und 1 Sonderzeichen enthalten',
  newPasswordEmpty: 'Neues Passwort darf nicht leer sein.',
  currentPasswordEmpty: 'Passwort darf nicht leer sein.',
  eightCharacters: 'Das Passwort muss mindestens 8 Zeichen lang sein',
  userNotFound: 'Für diese E-Mail-Adresse existiert kein Kundenkonto.',
  invalidCurrentPassword: 'Das aktuelle Passwort ist nicht korrekt',
  passwordsNotEqual: 'Neue Passwörter stimmen nicht überein.',
  minSpecialCharacter: 'Das Passwort muss mindestens 1 Sonderzeichen enthalten.',
  passwordChanged: 'Das Passwort wurde geändert.',
  samePasswords: 'Das neue Passwort darf nicht dem alten Passwort entsprechen.',
}

export default forgottenPassword
